import { SearchConfig } from "../../../../../types/search";

export type OptionKeys = "srNumber" | "categoryName";

export const searchByOptions: SearchConfig<OptionKeys>[] = [
  { value: "srNumber", label: "Sr no.", controlType: "text" },
  { value: "categoryName", label: "Category", controlType: "text" },
];
